import { useQuery } from "@/composables/useQuery.js";
import { getTraducaoConsumo } from "@/modules/central_consumo/services.js";

export function useTraducaoConsumo() {
  return useQuery({
    key: ["traducoes", "consumo"],
    queryFn: getTraducaoConsumo,
    select: (response) => response.data,
  });
}
